import axios from 'axios'
import { apiUrl } from '../../config'
import interceptors from './interceptors'

// allow use http client without Vue instance
export const http = axios.create({
    baseURL: apiUrl,
    withCredentials: true
})

// receive store and data by options
// https://vuejs.org/v2/guide/plugins.html
export default function install(Vue, { store, router }) {
    interceptors(http, store, router)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
    Object.defineProperty(Vue.prototype, '$http', {
        get() {
            return http
        },
    })
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js